isNextPlanPriceIncresed